import { useQuery } from '@tanstack/react-query';
import { ConversationRatingPage } from './ConversationRating.page';
import { QueryKey } from '@/Config/api/queryKey';
import { ConversationRatingConfigDto } from '@/Domain/api/WIdget/dto/ConversationRatingConfig.dto';
import { useSubscription } from '@/Domain/components/SubscriptionProvider';

export const ConversationRatingLoader = () => {
  const { isFetched, isActivated: isAvailable } = useSubscription();
  const { isLoading, data: conversationRatingConfiguration } =
    useQuery<ConversationRatingConfigDto>({
      queryKey: [QueryKey.conversationRatingConfiguration.get],
    });

  if (!isFetched) return null;
  if (isFetched && isAvailable('conversation_rating') && isLoading) return null;

  return (
    <ConversationRatingPage
      isAvailable={isAvailable('conversation_rating')}
      configuration={conversationRatingConfiguration}
    />
  );
};
